import React from "react"
import { Map as MapBS } from "@outdoormap/gatsby-plugin-brand-sites"

export default function Map({ ...props }) {
  return <MapBS trailControl="false" {...props} />
}
